'use client';

import { useModal } from '@/components/modals/modal-provider';
import { PricingCard } from '@/components/pricing-card';
import { Section } from '@/components/ui/section';
import { PRICING_TIERS } from '@/lib/pricing';

interface PricingSectionProps {
  className?: string;
}

export function PricingSection({ className }: PricingSectionProps) {
  const { openModal } = useModal();

  return (
    <Section
      title="Plans"
      subtitle="All plans include our core deep integration features."
      className={className}
    >
      <div className="flex flex-wrap justify-center gap-x-8 gap-y-8 lg:justify-between lg:gap-x-0">
        {PRICING_TIERS.map((tier, index) => (
          <PricingCard key={index} tier={tier} />
        ))}
      </div>

      <div className="text-center">
        <p className="text-muted-foreground">
          Need help choosing?{' '}
          <button
            onClick={() => openModal('contact', 'pricing')}
            className="cursor-pointer font-medium text-primary underline-offset-4 hover:underline"
          >
            contact our team
          </button>
          .
        </p>
      </div>
    </Section>
  );
}
